export default __webpack_public_path__ + "static/collecting-1beaa9fb5eaf0e1e779e9deed24236c9.svg";